import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { CloseOutlined } from '@ant-design/icons'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Input, InputNumber, Button } from 'hljd'
import Store from './store'
import style from './style.module.less'
import CheckInput from '@components/LocalMerchant/SetMealCreate/CheckInput'

const Item = Form.Item
@Form.create()
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(props.form)
  }
  componentDidMount() {
    const { key, value } = this.props.data
    this.store.init(key, value)
  }
  render() {
    const { doubleInputValue, addInput, deleteLastValue } = this.store
    const { text, addButton, required, key, options } = this.props.data
    const { getFieldDecorator } = this.props.form

    const placeholder1 = options[0].title
    const placeholder2 = options[1].title
    return (
      <>
        {required ? (
          <p className={style.label}>{text}</p>
        ) : (
          <p className={style.labelCommon}>{text}</p>
        )}
        {doubleInputValue.value.map((item, index) => {
          return (
            <div className={style.content} key={index}>
              <Item>
                {getFieldDecorator(`${key}-${index}-title`, {
                  initialValue: item.title,
                  rules: [{ required, message: `${text}信息未填写` }]
                })(
                  <CheckInput>
                    <Input className={style.area} placeholder={placeholder1} />
                  </CheckInput>
                )}
              </Item>
              <Item>
                {getFieldDecorator(`${key}-${index}-extra`, {
                  initialValue: item.extra,
                  rules: [{ required, message: `${text}信息未填写` }]
                })(
                  <InputNumber
                    className={style.area}
                    placeholder={placeholder2}
                    min={0}
                    precision={0}
                  />
                )}
              </Item>
              {index === doubleInputValue.value.length - 1 && (
                <CloseOutlined
                  className={style.deleteBtn}
                  onClick={deleteLastValue}
                />
              )}
            </div>
          )
        })}
        <Button onClick={addInput}>{addButton}</Button>
      </>
    )
  }
}
